import { FC } from 'react'
import styles from './TitleBlockForEditPages.module.css'
import { useMediaQuery } from 'react-responsive'
import CustomButton from '../UI/CustomButton/CustomButton'
import iconEdit from '../../assets/icons/iconEdit.svg'
import { useNavigate } from 'react-router-dom'

export type TitleBlockForEditPagesPropsType = {
  title: string
  disabled: boolean
  handleSubmit: () => void
  handleReset?: () => void
  setEdit?: (edit: boolean) => void
}

const TitleBlockForEditPages: FC<TitleBlockForEditPagesPropsType> = ({
  title,
  disabled,
  handleSubmit,
  setEdit,
}) => {
  const navigate = useNavigate()

  const cancelFC = () => {
    if (setEdit) {
      setEdit(false)
    } else {
      navigate(-1)
    }
  }
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
  return (
    <div className={styles.titleBlock}>
      <h2 className={styles.title}>{title}</h2>
      {!disabled && (
        <div className={styles.btnsBlock}>
          <CustomButton className={styles.canselBtn} title={'Отменить'} onClick={cancelFC} />
          <CustomButton className={styles.btn} title={'Сохранить'} onClick={handleSubmit} />
        </div>
      )}
    </div>
  )
}

export default TitleBlockForEditPages
